import { render, staticRenderFns } from "./EnlaceComponent.vue?vue&type=template&id=4bc5105d&scoped=true"
import script from "./EnlaceComponent.vue?vue&type=script&lang=js"
export * from "./EnlaceComponent.vue?vue&type=script&lang=js"
import style0 from "./EnlaceComponent.vue?vue&type=style&index=0&id=4bc5105d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc5105d",
  null
  
)

export default component.exports